import { render, staticRenderFns } from "./topic-card.vue?vue&type=template&id=19f13eb7&scoped=true&"
import script from "./topic-card.vue?vue&type=script&lang=js&"
export * from "./topic-card.vue?vue&type=script&lang=js&"
import style0 from "./topic-card.vue?vue&type=style&index=0&id=19f13eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f13eb7",
  null
  
)

export default component.exports